<template>
  <div class="product-badges" :class="{'border-none': (product.labels && product.labels.length)}" v-if="product && product.badges.length">
    <div class="badges-item" 
      v-for="(badge, index) in product.badges" 
      :style="{'color': badge.color}"
      @click="jump(badge)"
    >
      <div class="circle" v-if="index !== 0">·</div>
      {{ badge.text }}
    </div>
  </div>
</template>

<script>
import { transformLink } from '@/link'
export default {
  props: ['product'],

  methods: {
    jump ({ link }) {
      const _link = transformLink({
        link: {
          type:'deeplink',
          value: link
        }
      })

      window.location.href = _link
    }
  }
}
</script>

<style lang="stylus">

</style>





// WEBPACK FOOTER //
// product-badges.vue?78fd4a6c